import {
  UPLOAD_PATENT_SET,
  UPLOAD_PATENT_SET_SUCCESS,
  UPLOAD_PATENT_SET_ERROR,
  UPLOAD_PATENT_RESET
} from "../actions";

const INIT_STATE = {
  file: []
};
export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPLOAD_PATENT_SET:
      return { ...state };
    case UPLOAD_PATENT_SET_SUCCESS:
      return {
        ...state,
        file: [...state.file, action.payload]
      };
    case UPLOAD_PATENT_SET_ERROR:
      return { 
        ...state,
        file: [...state.file, action.payload]
      };
    case UPLOAD_PATENT_RESET:
      return {
        ...state,
        file: []
      };
    default:
      return { ...state };
  }
};
